import React, { useState } from "react";
import { Input } from "antd";
import { useIsMobile } from "../../Hooks";

const CustomInput = ({
  value,
  className,
  name,
  placeholder,
  onChange,
  maxlength = 60,
  error = false,
  regex = /[^a-zA-Z0-9[/]]/g,
  disabled = false,
}) => {
  const isMobile = useIsMobile();
  return (
    <div>
      <Input
        className={`${className} ${"cls_mghunq2c_40cb29"}`}
        name={name}
        placeholder={placeholder}
        onChange={(e) => {
          e.target.value = e.target.value.replace(regex, "");
          return onChange(e);
        }}
        maxLength={maxlength}
        disabled={disabled}
        value={value} />
    </div>
  );
};

export { CustomInput };
